<template>
    <div class="CurriculumData">
        <!--上面部分-->
        <culumTop :eventInfoData="qbinfo"></culumTop>
        <!--下面部分-->
        <div class="curriculumList padding-20 bgc box-shadow">
            <div class="filters">
                <div class="add">
                    <el-button  type="primary" @click="uploadEvent">上传资料</el-button>
                </div>
                <div class="search">
                    <el-input v-model="param.name" placeholder="请输入资料名称" class="condition" clearable></el-input>
                    <el-button type="primary" plain @click="handleQuery">搜索</el-button>
                </div>
            </div>
            <div class="result-list btn-operate-list">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="name" label="资料名称" class-name="title"></el-table-column>
                    <el-table-column label="资料格式" class-name="center">
                        <template slot-scope="scope">
                            <p>{{scope.row.doctype==1?'pdf':'ppt'}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="filesize" label="资料大小" class-name="center"></el-table-column>
                    <el-table-column prop="datetime" label="上传时间" class-name="center"></el-table-column>
                    <el-table-column label="操作"  width="260"  label-class-name="tr">
                        <template slot-scope="scope">
                            <div class="tr">
                                <el-button @click="handleDel(scope.row)" type="text" size="small">删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <page :total="total" @getList="_getList" ref="page"></page>
            </div>
        </div>
        <UploadData ref="uploadData" @getList="_getList"></UploadData>
    </div>
</template>

<script>
    import {getQBDocList, deleteQBDoc} from 'api/questionApi'
    import Page from 'base/page/page'
    import UploadData from './components/uploadData'
    import CulumTop from './components/culumTop'
    import {mapGetters, mapActions} from 'vuex'
    export default {
        name: "CurriculumData",
        data(){
            return{
                param:{
                    name:'',
                    qbid:this.$route.query.innerid
                },
                total: 0,
                tableData: [],
                qbinfo:{}
            }
        },
        mounted(){
            this._getList()
        },
        methods:{
            _getList() {
                this.setLoading(true)
                getQBDocList({
                    data: Object.assign({}, this.param, this.page),
                    success: data => {
                        if(this.page.page===1){
                            this.qbinfo= data.data.qbinfo
                        }
                        this.tableData = data.data.content
                        this.total = data.data.pageinfo.rowCount
                        this.setLoading(false)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            handleQuery() {
                this.$refs.page.handleSizeChange(1)
            },
            // 上传资料
            uploadEvent(){
                this.$refs.uploadData.open()
            },
            // 删除
            handleDel(row){
                this.$confirm('确定删除该资料吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.setLoading(true)
                    deleteQBDoc({
                        data: {
                            qbid:this.$route.query.innerid,
                            innerid:row.innerid
                        },
                        success: data => {
                            console.log(data)
                            this.setLoading(false)
                            this.$message.success('操作成功')
                            this._getList()
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {})
            },
            ...mapActions([
                'setLoading',
            ])
        },
        computed: {
            ...mapGetters([
                'page'
            ])
        },
        components: {
            Page, UploadData, CulumTop
        }
    }
</script>

<style lang="scss">
    .CurriculumData{
        .curriculumList {
            margin-top: 20px;
            .add {
                .el-button {
                    margin-left: 0;
                    margin-right: 20px;
                }
            }
            .el-dropdown {
                cursor: pointer;
            }
            .btn-operate-list .separator {
                font-size: 12px;
                font-style:normal;
            }
            .tc-complete {
                color: rgb(230, 162, 60) !important;
            }
            .result-list{
                .share {
                    display: inline-block;
                }
                .el-table__row{
                    height: 100px;
                }
                .imageText{
                    .imageText-summary{
                        margin-left: 5px;
                        .textBox{
                            width: 250px;
                            height: 40px;
                            line-height: 20px;
                            overflow: hidden;
                            .text{
                                // float: right;
                                /* "margin-left"要等于".wrap::before"的宽度 */
                                // margin-left: -10px;
                                // width: 340px;
                                word-break: break-all;
                                text-overflow: -o-ellipsis-lastline;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                                word-break: break-all;
                                // font-size: 0.48rem;
                            }
                            &::before {
                                float: left;
                                content: '';
                                width: 5px;
                                height: 100%;
                            }
                            &::after {
                                float: right;
                                content: "...";
                                /* 行高与".wrap"设置的一致即可 */
                                height: 40px;
                                line-height: 20px;
                                /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                                width: 37px;
                                margin-left: -30px;
                                position: relative;
                                left: 96%;
                                bottom: 20px;
                                font-weight: 600;
                                padding-right: 1px;
                                background: #fff;
                                transition: all 0.5s;
                            }
                            .recommon{
                                color: #fff;
                                background: #E6A23C;
                                display: inline-block;
                                width: 36px;
                                height: 16px;
                                line-height: 16px;
                                text-align: center;
                                margin-right: 5px;
                                font-size: 12px;
                            }
                        }
                        .price{
                            margin-left: 5px;
                            color: #F56C6C;
                        }
                    }
                }
                .el-table__row:hover{
                    .textBox{
                        &::after{
                            background: #F5F7FA;
                        }
                    }
                }
                img{
                    min-width: 100px;
                    max-width: 100px;
                    height: 60px;
                }
                .icon{
                    margin-left: 10px;
                    width: 14px;
                    height: 14px;
                }
            }
            .result-list .imageText .imageText-summary div:nth-child(1){
                margin-bottom: 0;
            }
            .el-table{
                .title{
                    .cell{
                        padding: 0;
                        margin-left: 5px;
                    }
                }
                .center{
                    .cell{
                        text-align: center;
                    }
                }
            }
        }
    }
</style>
